import React, {ComponentProps} from 'react';
import {DataGrid} from '@mui/x-data-grid';

const Table = (props: ComponentProps<typeof DataGrid>) => {
  return <DataGrid {...props} />;
};

export default Table;
